module.exports = __webpack_public_path__ + "img/transfer.a1d1eb91.svg";